import React from "react";
import { FormHelperText, Select, TextFieldProps } from "@material-ui/core";
import { SelectProps } from "@material-ui/core/Select/Select";

import {
  useSelectStyles,
  SelectBaseInput,
  useBaseStyles,
  useHelperTextStyles,
} from "./InputSelect.style";

export const InputSelect = (props: SelectProps | any) => {
  const baseClasses = useBaseStyles(props);
  const selectClasses = useSelectStyles(props);
  const textHelperClasses = useHelperTextStyles(props);

  return (
    <div className={baseClasses.root}>
      {props.label ? <label htmlFor={props.id}>{props.label}</label> : <></>}
      <Select
        classes={selectClasses}
        MenuProps={{ classes: { paper: selectClasses.select } }}
        displayEmpty
        {...props}
        input={<SelectBaseInput {...props} />}
      >
        {props.children}
      </Select>

      {(props as any).helperText ? (
        <FormHelperText className={textHelperClasses.root}>
          {(props as TextFieldProps).helperText}
        </FormHelperText>
      ) : (
        <></>
      )}
    </div>
  );
};
